import {
  getListUserAnswer,
  createUserAnswer,
  getDetailUserAnswer,
  changeStatusAnswer,
  getListUserAnswerByUserId,
  getListUserSubmittions
} from "./../api.js";

export const state = {
  listUserAnswerResponse: {},
  detailUserAnswer: {},
  listUserAnswerByUserIdResponse: {},
  listUserSubmittionsByProblem: {}
};

export const getters = {
  listUserAnswerResponse: state =>
    state.listUserAnswerResponse ? state.listUserAnswerResponse.data : [],
  detailAnswer: state => state.detailUserAnswer ? state.detailUserAnswer : [],
  listUserAnswerByUserIdResponse: state =>
    state.listUserAnswerByUserIdResponse
      ? state.listUserAnswerByUserIdResponse.data
      : [],
  pagination: state =>
  state.listUserAnswerResponse
    ? state.listUserAnswerResponse
    : {},
  paginationByUserId: state =>
    state.listUserAnswerByUserIdResponse
      ? state.listUserAnswerByUserIdResponse
      : {},
  listUserSubmittionsByProblem: state =>
    state.listUserSubmittionsByProblem
      ? state.listUserSubmittionsByProblem.data
      : []
};

export const mutations = {
  getList(state, data) {
    state.listUserAnswerResponse = data.data;
  },
  getDetail(state, data) {
    state.detailUserAnswer = data.data;
  },
  getListByUserId(state, data) {
    state.listUserAnswerByUserIdResponse = data.data;
  },
  getListUserSubmittions(state, data) {
    state.listUserSubmittionsByProblem = data.data;
  }
};

export const actions = {
  async getList({ commit }, query) {
    let data = await getListUserAnswer(query);
    commit("getList", data);
  },
  async create({ commit }, query) {
    let data = await createUserAnswer(query);
    commit("getList", data);
  },
  async getDetail({ commit }, query) {
    let data = await getDetailUserAnswer(query);
    commit("getDetail", data);
  },
  async changeStatus({ commit }, query) {
    let data = await changeStatusAnswer(query);
    commit("getDetail", data);
  },
  async getListByUserId({ commit }, query) {
    let data = await getListUserAnswerByUserId(query);
    commit("getListByUserId", data);
  },
  async getUserSubmittions({ commit }, query) {
    let data = await getListUserSubmittions(query);
    commit("getListUserSubmittions", data);
  }
};
